import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AccordionModule } from 'primeng/accordion';
import { GalleriaModule } from 'primeng/galleria';
import { RatingModule } from 'primeng/rating';
import { CarouselModule } from 'primeng/carousel';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IntercptorService } from './services/intercptor.service';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { BadgeModule } from 'primeng/badge';
import { DialogModule } from 'primeng/dialog';
import { HomeComponent } from './pages/home/home.component';
import { CheckboxModule } from 'primeng/checkbox';
import { SliderModule } from 'primeng/slider';
import { MenubarModule } from 'primeng/menubar';
import { MegaMenuModule } from 'primeng/megamenu';

import { NotFoundComponent } from './pages/not-found/not-found.component';
import { FooterComponent } from './components/footer/footer.component';

import { HeaderComponentComponent } from './components/header-component/header-component.component';
import { BottomNavComponent } from './components/bottom-nav/bottom-nav.component';
import { InputNumberModule } from 'primeng/inputnumber';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { TimelineModule } from 'primeng/timeline';
import { ProductCardComponent } from './components/product-card/product-card.component';
import { ProductsComponentComponent } from './pages/home/components/products-component/products-component.component';
import { BannerComponent } from './pages/home/components/banner/banner.component';
import { BlogComponent } from './pages/home/components/blog/blog.component';
import { ProductDetailsComponent } from './pages/product-details/product-details.component';
import { CustomizationComponent } from './pages/customization/customization.component';
import { CustomizeShirtComponent } from './pages/customization/components/customize-shirt/customize-shirt.component';
import { InlineSVGModule } from 'ng-inline-svg';
import { CustomizeShortComponent } from './pages/customization/components/customize-short/customize-short.component';
import { CustomizeSocksComponent } from './pages/customization/components/customize-socks/customize-socks.component';
import { CategoryComponent } from './pages/home/components/category/category.component';
import { ClientComponent } from './pages/home/components/client/client.component';
import { CatalogueComponent } from './pages/home/components/catalogue/catalogue.component';
import { ProductsComponent } from './pages/products/products.component';
import { CategoriesComponent } from './pages/categories/categories.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { WishlistComponent } from './pages/wishlist/wishlist.component';
import { FilterComponent } from './pages/products/component/filter/filter.component';
import { HeroVideoComponent } from './pages/home/components/hero-video/hero-video.component';
import { HomeAppComponent } from './pages/home/components/home-app/home-app.component';
import { HomeAppTopComponent } from './pages/home/components/home-app-top/home-app-top.component';
import { ChooseSizesComponent } from './pages/customization/components/choose-sizes/choose-sizes.component';
import { BlogsComponent } from './pages/blogs/blogs/blogs.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LanguageUrlInterceptor } from './interceptors/language-url.interceptor';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { TCComponent } from './pages/t-c/t-c.component';
import { ArticleComponent } from './pages/article/article.component';
import { CartPageComponent } from './pages/cart/cart-page.component';
import { QuantitySelectorComponent } from './pages/cart/components/quantity-selector/quantity-selector.component';
import { CartItemCardComponent } from './pages/cart/components/cart-item-card/cart-item-card.component';
import { OrderSummaryComponent } from './pages/cart/components/order-summary/order-summary.component';
import { CheckoutFooterComponent } from './pages/cart/components/checkout-footer/checkout-footer.component';
import { PersonalInformationPageComponent } from './pages/profile/personal-information-page/personal-information-page.component';
import { ChangePasswordPageComponent } from './pages/profile/change-password-page/change-password-page.component';
import { AddressCardComponent } from './components/address-card/address-card.component';
import { AddressesPageComponent } from './pages/profile/addresses-page/addresses-page.component';
import { AddressFormPageComponent } from './pages/profile/address-form-page/address-form-page.component';
import { AddressService } from './services/address/address.service';
import { LoginComponent } from './pages/login/login.component';
import { RegisterComponent } from './pages/register/register.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { ChooseLanguageComponent } from './pages/choose-language/choose-language.component';
import { VerifyOtpComponent } from './pages/verify-otp/verify-otp.component';
import { CreatePasswordComponent } from './pages/create-password/create-password.component';

import { CheckoutComponent } from './pages/checkout/checkout.component';
import { OrderConfirmationComponent } from './pages/order-confirmation/order-confirmation.component';
import { MyordersComponent } from './pages/profile/myorders/myorders.component';
import { OrderDetailsComponent } from './pages/profile/myorders/components/order-details/order-details.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    NotFoundComponent,
    FooterComponent,
    HeaderComponentComponent,
    BottomNavComponent,
    ProductCardComponent,
    ProductsComponentComponent,
    BannerComponent,
    BlogComponent,
    ProductDetailsComponent,
    CustomizationComponent,
    CustomizeShirtComponent,
    CustomizeShortComponent,
    CustomizeSocksComponent,
    ChooseSizesComponent,
    CategoryComponent,
    ClientComponent,
    CatalogueComponent,
    ProductsComponent,
    CategoriesComponent,
    ProfileComponent,
    PersonalInformationPageComponent,
    ChangePasswordPageComponent,
    AddressCardComponent,
    AddressesPageComponent,
    AddressFormPageComponent,
    LoginComponent,
    RegisterComponent,
    ForgotPasswordComponent,
    ChooseLanguageComponent,
    VerifyOtpComponent,
    CreatePasswordComponent,
    WishlistComponent,
    FilterComponent,
    HeroVideoComponent,
    HomeAppComponent,
    HomeAppTopComponent,
    BlogsComponent,
    PrivacyPolicyComponent,
    AboutUsComponent,
    TCComponent,
    ArticleComponent,
    CartPageComponent,
    QuantitySelectorComponent,
    CartItemCardComponent,
    OrderSummaryComponent,
    CheckoutFooterComponent,
    CheckoutComponent,
    OrderConfirmationComponent,
    MyordersComponent,
    OrderDetailsComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CommonModule,
    BadgeModule,
    CarouselModule,
    AccordionModule,
    HttpClientModule,
    RatingModule,
    FormsModule,
    GalleriaModule,
    BrowserAnimationsModule,
    SweetAlert2Module.forRoot(),
    DialogModule,
    CheckboxModule,
    SliderModule,
    MenubarModule,
    MegaMenuModule,
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    InputNumberModule,
    CalendarModule,
    DropdownModule,
    ReactiveFormsModule,
    TimelineModule,
    InlineSVGModule.forRoot(),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: IntercptorService, multi: true },
    LanguageUrlInterceptor,
    AddressService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
